<template lang="pug">
.page.page--light.faq
  .page__cover.pd-cover
    .pd-container
      .page__caption(data-aos="fade-down") Terms of Service
      .page__description(data-aos="zoom-out") Standard service terms

      .links.el-button-group(
        data-aos="fade-in"
        v-if="!iframed")
        nuxt-link.el-button(
          active-class="el-button--primary"
          :to="{ name: 'terms-of-service-brands' }") For Brands
        nuxt-link.el-button(
          active-class="el-button--primary"
          :to="{ name: 'terms-of-service-retailers' }") For Retailers

  .page__section
    .pd-container.framed
      nuxt-child
</template>

<script>
import iframe from '~/mixins/iframe'

export default {
  mixins: [iframe],

  data () {
    return {
      title: 'Terms of Service'
    }
  },

  head () {
    return this.$seo.head({
      title: this.title,
      description: 'Learn more about Pod Food\'s Terms of Service for Customers here.'
    })
  }
}
</script>

<style lang="scss" scoped>
.links {
  margin-top: 2em;
}
</style>
